export default __webpack_public_path__ + "static/media/speaker.769e1078.svg";